import { useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Share2, Loader2 } from "lucide-react";
import { Panel } from "@/components/Bits";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export const WhatsAppShare = ({ os, auto, onAutoDone }) => {
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    const win = window.open("", "_blank");
    try {
      const { data } = await api.post(`/ordens/${os.os_id}/compartilhar`);
      const url = `https://wa.me/${data.telefone || ""}?text=${encodeURIComponent(data.mensagem)}`;
      if (win) win.location.href = url; else window.location.href = url;
      if (!data.telefone) toast.info("Cliente sem WhatsApp cadastrado: escolha o contato no WhatsApp");
    } catch (e) {
      win?.close();
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  const shareFile = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/ordens/${os.os_id}/pdf`, { responseType: "blob" });
      const file = new File([data], `${os.numero}.pdf`, { type: "application/pdf" });
      await navigator.share({ files: [file], title: os.numero, text: `Ordem de Serviço ${os.numero} — Fazenda Digital` });
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Não foi possível compartilhar o arquivo");
    } finally {
      setBusy(false);
    }
  };

  const canShareFile = typeof navigator !== "undefined" && navigator.canShare?.({ files: [new File([""], "a.pdf", { type: "application/pdf" })] });

  return (
    <Panel title="Enviar OS encerrada (descrição e valores)" testId="os-whatsapp">
      <div className="grid sm:grid-cols-2 gap-3">
        <button onClick={send} disabled={busy} data-testid="os-whatsapp-button"
          className="h-14 rounded-xl bg-[#25D366] text-white font-semibold flex items-center justify-center gap-2 hover:opacity-90 active:scale-[0.98] disabled:opacity-60">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <MessageCircle className="h-5 w-5" />} Enviar ao responsável pela fazenda
        </button>
        {canShareFile && (
          <button onClick={shareFile} disabled={busy} data-testid="os-share-file-button"
            className="h-14 rounded-xl border-2 border-[#E2DDD3] bg-white font-semibold flex items-center justify-center gap-2 hover:border-[#1E4D2B]">
            <Share2 className="h-5 w-5" /> Compartilhar arquivo PDF
          </button>
        )}
      </div>
      <p className="mt-3 text-xs text-[#5C6B66]">Abre o WhatsApp do responsável pela fazenda com a descrição, o valor total e o link do PDF (válido por 30 dias).</p>
      <Dialog open={!!auto} onOpenChange={(o) => !o && onAutoDone()}>
        <DialogContent className="max-w-md rounded-3xl" data-testid="os-autosend-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl">OS encerrada</DialogTitle></DialogHeader>
          <p className="text-[#5C6B66] -mt-2">Envie agora a {os.numero} com descrição e valores para o WhatsApp do responsável pela fazenda.</p>
          <button onClick={() => { onAutoDone(); send(); }} data-testid="os-autosend-button" className="h-14 rounded-xl bg-[#25D366] text-white font-semibold flex items-center justify-center gap-2"><MessageCircle className="h-5 w-5" /> Enviar no WhatsApp</button>
          <button onClick={onAutoDone} className="h-12 text-[#5C6B66] font-semibold" data-testid="os-autosend-skip">Depois</button>
        </DialogContent>
      </Dialog>
    </Panel>
  );
};
